<template>
  <BaseEditModal
    displayName="Create Scene"
    helpFileName="CreateSceneModal"
    :tabs="tabs"
    :icon="'mdi-cube-outline'"
    hideBottomButtons
    :customState="scenesToCreate"
    @close="emit('close')"
    @locked="(bool) => emit('locked', bool)"
    @activeTab="handleTabChange">
    <template v-slot:prepend-buttons>
      <v-btn
        :loading="createSceneLoading"
        block
        color="primary"
        variant="flat"
        @click="createScenes">
        <v-icon class="mr-2">mdi-cube-send</v-icon>
        Create Scenes
      </v-btn>
    </template>
  </BaseEditModal>
  <div></div>
</template>
<script setup>
import { ref } from 'vue';
import { deluge } from '../../stores/deluge';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import { $http } from '../../stores/http';

//  Sub Components
import CreateSceneFromAssets from './CreateSceneModalComponents/CreateSceneFromAssets.vue';
import CreateSceneFromTemplates from './CreateSceneModalComponents/CreateSceneFromTemplates.vue';
import CreateSceneFromPresets from './CreateSceneModalComponents/CreateSceneFromPresets.vue';

const props = defineProps([
  'channel_did',
  'qid',
  'qdid',
  'go_to_tab',
  'existing_scene',
]);
const emit = defineEmits(['close', 'locked', 'deleted']);

console.log('props');

const scenesToCreate = ref(setScenesToCreate());
const createSceneLoading = ref(false);
const activeTabIndex = ref(0);

function setScenesToCreate() {
  console.log('Setting Scenes To Create');
  return {
    asset_ids: [],
    template_ids: [],
    preset_ids: [],
  };
}

// Tabs - must be 0 indexed.
const tabs = [
  {
    id: 0,
    title: 'From an Asset',
    icon: 'mdi-file-image',
    display: true,
    component: CreateSceneFromAssets,
  },
  {
    id: 1,
    title: 'From a Template',
    icon: 'mdi-cube-scan',
    display: true,
    component: CreateSceneFromTemplates,
  },
  {
    id: 2,
    title: 'From a Template Preset',
    icon: 'mdi-tune-variant',
    display: true,
    component: CreateSceneFromPresets,
  },
];

function createScenes() {
  createSceneLoading.value = true;

  var create_scenes_obj = {
    qid: props.qid,
    asset_ids: [],
    template_ids: [],
    scene_ids: [],
  };

  if (activeTabIndex.value === 0) {
    create_scenes_obj.asset_ids = scenesToCreate.value.asset_ids;
  }
  if (activeTabIndex.value === 1) {
    create_scenes_obj.template_ids = scenesToCreate.value.template_ids;
  }
  if (activeTabIndex.value === 2) {
    create_scenes_obj.template_ids = scenesToCreate.value.preset_ids;
  }

  $http(
    'POST',
    '/dynamic_engine/scenes_from_assets',
    JSON.stringify(create_scenes_obj)
  ).then(() => {
    createSceneLoading.value = false;
    emit('close');
  });
}

function handleTabChange(tab) {
  scenesToCreate.value = setScenesToCreate();
  console.log('Tab Changed', tab);
  activeTabIndex.value = tab;
}
</script>

<style scoped>
#assets-onair-wrapper .assets-container {
  max-height: calc(105vh - 640px);
}

.selected {
  background-color: var(--v-primary-base);
  color: rgb(255, 255, 255);
}

.tag-container {
  display: flex;
  align-items: center;
}

.tag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tag-name {
  font-size: 14px;
  font-weight: bold;
  margin: 2px;
}

/* Default background color for tags */
.tag-default {
  opacity: 0.4 !important;
  color: white;
}

.button-highlight {
  background-color: var(--v-primary-base);
  color: white;
}
</style>
